import { Typography, Paper } from "@mui/material"
import styles from "./DisciplinaryTimeline.module.css"

interface TimelineEvent {
  id: string
  date: string
  title: string
  description: string
  type: string
  actor: string
}

interface DisciplinaryTimelineProps {
  events: TimelineEvent[]
}

export default function DisciplinaryTimeline({ events }: DisciplinaryTimelineProps) {
  if (!events || events.length === 0) {
    return (
      <div className={styles.emptyState}>
        <Typography variant="body1" color="textSecondary">
          No timeline events available.
        </Typography>
      </div>
    )
  }

  // Sort events by date (newest first)
  const sortedEvents = [...events].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())

  const getEventColor = (type: string) => {
    switch (type) {
      case "pending":
        return styles.queryIssued
      case "response_submitted":
        return styles.responseSubmitted
      case "penalty_applied":
        return styles.penaltyApplied
      case "case_closed":
        return styles.caseClosed
      case "warning_issued":
        return styles.warningIssued
      default:
        return styles.defaultEvent
    }
  }

  return (
    <div className={styles.timeline}>
      {sortedEvents.map((event, index) => (
        <div key={event.id} className={styles.timelineItem}>
          <div className={`${styles.timelineDot} ${getEventColor(event.type)}`}>
            <span className={styles.timelineDotInner}></span>
          </div>
          <Paper elevation={1} className={styles.timelineContent}>
            <div className={styles.timelineHeader}>
              <Typography variant="subtitle1" className={styles.timelineTitle}>
                {event.title}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {new Date(event.date).toLocaleString()}
              </Typography>
            </div>
            <Typography variant="body2" className={styles.timelineDescription}>
              {event.description}
            </Typography>
            <Typography variant="caption" color="textSecondary" className={styles.timelineActor}>
              By: {event.actor}
            </Typography>
          </Paper>
        </div>
      ))}
    </div>
  )
}
